import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 90%;
  max-width: 1024px;
  margin: 30px auto;
`;

export default { PageContainer };
